import type { Provider } from '../PreCheckedProviders.types'

/**
 * Creates a set from the Professional providers and compares it to the Facility
 * providers to determine if there is a duplicate provider between both arrays
 *
 * @param professional Array of professional providers
 * @param facility Array of facility providers
 * @returns True if there are duplicate provider names
 */
export const checkProfessionalFacilityDuplicates = (
  professional: Provider[] = [],
  facility: Provider[] = [],
): boolean => {
  // Transform provider objects into a Set of names for efficient lookup
  const professionalNames = new Set(
    professional.map(provider => provider.providerName),
  )

  // Collect unique matching provider names in a Set
  const matchedNames = new Set(
    facility
      .filter(provider => professionalNames.has(provider.providerName))
      .map(provider => provider.providerName),
  )

  return matchedNames.size > 0
}
